/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuoteRestrictionType } from './QuoteRestrictionType';
import {
    QuoteRestrictionTypeFromJSON,
    QuoteRestrictionTypeFromJSONTyped,
    QuoteRestrictionTypeToJSON,
    QuoteRestrictionTypeToJSONTyped,
} from './QuoteRestrictionType';

/**
 * 
 * @export
 * @interface QuoteRestriction
 */
export interface QuoteRestriction {
    /**
     * 
     * @type {QuoteRestrictionType}
     * @memberof QuoteRestriction
     */
    type: QuoteRestrictionType;
    /**
     * HH:mm format. Used by pickup_open_before and delivery_close_after.
     * @type {string}
     * @memberof QuoteRestriction
     */
    time?: string;
    /**
     * 1-24. Used by min_transit_window_hours.
     * @type {number}
     * @memberof QuoteRestriction
     */
    hours?: number;
    /**
     * Human-readable description of this restriction.
     * @type {string}
     * @memberof QuoteRestriction
     */
    description: string;
}



/**
 * Check if a given object implements the QuoteRestriction interface.
 */
export function instanceOfQuoteRestriction(value: object): value is QuoteRestriction {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function QuoteRestrictionFromJSON(json: any): QuoteRestriction {
    return QuoteRestrictionFromJSONTyped(json, false);
}

export function QuoteRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteRestriction {
    if (json == null) {
        return json;
    }
    return {
        
        'type': QuoteRestrictionTypeFromJSON(json['type']),
        'time': json['time'] == null ? undefined : json['time'],
        'hours': json['hours'] == null ? undefined : json['hours'],
        'description': json['description'],
    };
}

  export function QuoteRestrictionToJSON(json: any): QuoteRestriction {
      return QuoteRestrictionToJSONTyped(json, false);
  }

  export function QuoteRestrictionToJSONTyped(value?: QuoteRestriction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': QuoteRestrictionTypeToJSON(value['type']),
        'time': value['time'],
        'hours': value['hours'],
        'description': value['description'],
    };
}

